"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Count = function Count(props) {
  var currentPage = props.currentPage,
    per = props.per,
    totalCount = props.totalCount;
  if (!currentPage || !per || !totalCount) {
    return null;
  }
  var start = _lodash["default"].add(1, _lodash["default"].multiply(per, _lodash["default"].subtract(currentPage, 1))) <= 1 ? 1 : _lodash["default"].add(1, _lodash["default"].multiply(per, _lodash["default"].subtract(currentPage, 1)));
  var end = _lodash["default"].multiply(per, currentPage) > totalCount ? totalCount : _lodash["default"].multiply(per * currentPage);
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "ui-pager-count"
  }, "".concat(start, "-").concat(end, " of ").concat(totalCount));
};
Count.propTypes = {
  currentPage: _propTypes["default"].number,
  per: _propTypes["default"].number,
  totalCount: _propTypes["default"].number
};
Count.defaultProps = {
  currentPage: null,
  per: null,
  totalCount: null
};
var _default = Count;
exports["default"] = _default;